// Axios:
// const axios = require('axios').default;



export default {
	namespace: 'donate-project',
	beforeEnter(barba) {
		
	},
	afterEnter(barba) {
		const header = document.querySelector('header.site-header')
		header.classList.add('donate-header')
		console.log('View: donate project')
	},
	beforeLeave(barba) {

	},
	afterLeave(barba) {
		const header = document.querySelector('header.site-header')
		header.classList.remove('donate-header')
	}
}
